import React, { ReactNode } from 'react'
import Modal from 'react-modal'
import { Close } from 'app/assets/icons'
import { style } from 'app/assets/styles'
import styled from 'styled-components'
import { colors, fonts } from 'app-v2/design-systems'
import { media } from '../../../../assets/styles'
import { SPACING } from '../../../../../app-v2/design-tokens'

const { bbqBrown } = colors

type BaseModalProps = {
    visible: boolean,
    onClose: () => void,
    cover?: ReactNode,
    body?: ReactNode,
    buttons?: ReactNode,
    title?: string,
    subtitle?: string | ReactNode
}

export const BaseModal = ({
    onClose,
    visible,
    buttons,
    cover,
    body,
    title,
    subtitle
}: BaseModalProps) => {
    return (
        <Modal
            isOpen={visible}
            ariaHide={false}
            shouldCloseOnOverlayClick
            onRequestClose={onClose}
            style={style.classicModalStyle}>
            <StyledCloseButtonContainer onClick={onClose}>
                <Close color={bbqBrown} size={24} />
            </StyledCloseButtonContainer>
            <StyledBody className={'tpkModal'}>
                {cover}
                {title ? <StyledModalTitle>{title}</StyledModalTitle> : null}
                {subtitle ? (
                    <StyledModalSubTitle>{subtitle}</StyledModalSubTitle>
                ) : null}
                {typeof body === 'string' ? (
                    <StyledModalText>{body}</StyledModalText>
                ) : (
                    body
                )}
                {buttons ? (
                    <StyledButtonContainer>{buttons}</StyledButtonContainer>
                ) : null}
            </StyledBody>
        </Modal>
    )
}

const StyledCloseButtonContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`

const StyledModalTitle = styled.h2`
    font-size: 20px;
    font-family: ${fonts.flameRegular};
    line-height: 1.2;
    color: ${colors.bbqBrown};
    text-align: center;
`

const StyledBody = styled.div`
    padding: ${SPACING.XXL} ${SPACING.S} ${SPACING.L} ${SPACING.S};
    ${media.small`padding: ${SPACING.XXL};`}
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
`

const StyledButtonContainer = styled.div`
    width: 100%;
    margin-top: ${SPACING.S};
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XXS};
    justify-content: center;
    align-content: center;
`
const StyledModalText = styled.p`
    margin: 0;
    text-align: ${props => (props.center ? 'center' : 'left')};
    color: ${colors.bbqBrown};
    line-height: 1.5;
    font-family: ${fonts.flameSansRegular};
    ${props => (props.small ? 'font-size: 14px;' : 'font-size: 16px;')}
`
const StyledModalSubTitle = styled(StyledModalText)`
    text-align: center;
    max-width: 350px;
`
